import { useTranslation } from 'react-i18next'
import RecognizeWineModal from 'components/Common/Modals/RecognizeWine'
import BottleItem from 'components/Pages/Wine/View/Main/Content/ProductSpecs/Package/BottleItem'
import {
  ChipsContainer,
  ChipsList,
  Item,
  ItemLabel,
} from 'components/Pages/Wine/View/Main/Content/ProductSpecs/_styles'
import styled from 'styled-components'
import { formatBottleSize } from 'utils/wine'
import { useCapturedWine } from '../../_methods/context'
import { useRecognizeAdd } from '../useRecognizeAdd'

const AddButton = styled.button`
  appearance: none;
  border: 1px solid #e7e7ea;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  height: 28px;
  padding: 5px 11px;
  font: var(--typography-14-16-semibold);
  color: #717284;
  white-space: nowrap;

  &:hover {
    border-color: #88122b;
  }
`

const Package = () => {
  const { t } = useTranslation()
  const { capturedWine, getCapturedWineUrl } = useCapturedWine()
  const capturedWineUrl = (id: string) =>
    getCapturedWineUrl ? getCapturedWineUrl(id) : `/acc/captured-wine/${id}`
  const { dialogOpen, setDialogOpen, handleConfirm, canAdd } = useRecognizeAdd(
    capturedWine.id
  )

  const products = capturedWine.products ?? []

  const currentVintage = capturedWine.product?.wine?.vintageText
  const currentBottleSize = capturedWine.product?.bottleSize?.id
  const currentPackageType = capturedWine.product?.packageType?.id

  const isCurrent = (p: (typeof products)[number]) =>
    p.product?.wine?.vintageText === currentVintage &&
    p.product?.bottleSize?.id === currentBottleSize &&
    p.product?.packageType?.id === currentPackageType

  const currentProduct = products.find(isCurrent)
  const otherProducts = products.filter(p => !isCurrent(p))

  return (
    <Item>
      <ItemLabel>{t('wine.view.package')}</ItemLabel>
      <ChipsContainer>
        <ChipsList>
          {currentProduct && (
            <BottleItem
              active
              size={formatBottleSize(
                currentProduct.product?.bottleSize?.volumeML
              )}
              packageType={currentProduct.product?.packageType}
              href={capturedWineUrl(currentProduct.id)}
            />
          )}

          {otherProducts.map(p => (
            <BottleItem
              key={p.id}
              active={false}
              size={formatBottleSize(p.product?.bottleSize?.volumeML)}
              packageType={p.product?.packageType}
              href={capturedWineUrl(p.id)}
            />
          ))}

          {canAdd && (
            <AddButton
              data-testid='captured-wine-package-add-button'
              onClick={() => setDialogOpen(true)}
            >
              + {t('wine.view.addBottle')}
            </AddButton>
          )}
        </ChipsList>
      </ChipsContainer>

      {dialogOpen && (
        <RecognizeWineModal
          onClose={() => setDialogOpen(false)}
          onConfirm={handleConfirm}
        />
      )}
    </Item>
  )
}

export default Package
